import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * enums
 */
import { SpinKitType } from '@sharedComponents/spinner/spinkit/enums/spinkit-type';

/**
 * directives
 */
import { SpinKitDirective } from '@sharedComponents/spinner/spinkit/directives/spin-kit.directive';

/**
 * @component SpinKitWaveComponent
 * @selector app-spin-kit-wave
 * @standalone true
 * @description
 * A SpinKit loader made of vertical bars moving in a wave-like pattern.
 * Dynamically generates bars and applies styling based on the current theme and config.
 * 
 * @example
 * <app-spin-kit-wave bgColor="var(--bs-success)/colorCode"></app-spin-kit-wave>
 */
@Component({
  selector: 'app-spin-kit-wave',
  templateUrl: './spin-kit-wave.component.html',
  styleUrl: './spin-kit-wave.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'null',
  },
  imports: [NgClass],
})
export class SpinKitWaveComponent extends SpinKitDirective {

  /**
   * @property type
   * @override
   * Specifies the loader style to be "wave".
   */
  protected override type = SpinKitType.Wave;

  /**
   * @property children
   * @description Generates 5 bars for the wave animation.
   */
  public children = this.createChildren(5);

  /**
   * @property buildClassStyleSkPart
   * @description Constructs the class name for each bar (e.g. sk-wave-rect).
   */
  public get buildClassStyleSkPart(): string {
    return `${this.buildClassStyle}-rect`;
  }

  /**
   * @constructor
   * Initializes wave loader.
   */
  constructor() {
    super();
  }
}